import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CalendarClock, Plus } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { BookingCard } from "@/components/BookingCard";
import { Button } from "@/components/ui/button";

export default function ClientDashboard() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/bookings/mine").then((r) => setBookings(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div className="max-w-5xl mx-auto px-6 lg:px-12 py-14">
      <div className="flex items-center justify-between mb-10">
        <div>
          <p className="text-[#C9A24B] text-xs tracking-[0.3em] uppercase mb-2">Espace client</p>
          <h1 className="font-serif text-4xl text-white">Bonjour, {user?.name}</h1>
          <p className="text-[#A19E95] mt-1">Suivez l'avancement de vos demandes de réservation.</p>
        </div>
        <Button onClick={() => navigate("/artistes")} className="gold-bg text-black font-semibold rounded-full hidden sm:inline-flex">
          <Plus size={16} className="mr-1" /> Nouvelle demande
        </Button>
      </div>

      {loading ? (
        <p className="text-[#A19E95] text-center py-20">Chargement...</p>
      ) : bookings.length === 0 ? (
        <div className="text-center py-20 border border-white/10 rounded-2xl" data-testid="client-empty">
          <CalendarClock className="text-[#C9A24B] mx-auto mb-4" size={40} />
          <p className="text-white font-serif text-2xl mb-2">Aucune demande pour l'instant</p>
          <p className="text-[#A19E95] mb-6">Explorez notre catalogue et réservez votre premier artiste.</p>
          <Button onClick={() => navigate("/artistes")} className="gold-bg text-black font-semibold rounded-full">
            Découvrir les artistes
          </Button>
        </div>
      ) : (
        <div className="space-y-4">
          {bookings.map((b) => <BookingCard key={b.id} b={b} />)}
        </div>
      )}
    </div>
  );
}
